

















import { Vue, Component, Prop } from 'vue-property-decorator';
import { EAuthenticationStepType } from '@signing-page/authentication/types/enums/authentication-step-type';
import { MergeTagHelper } from '@signing-page/helpers/merge-tag.helper';
import { IAuthenticationStep } from '@signing-page/authentication/types/authentication-step';

@Component
export default class Consent extends Vue {
  @Prop() consentStep: IAuthenticationStep;
  @Prop() value: boolean;

  get title(): string {
    switch (this.consentStep.type) {
      case EAuthenticationStepType.GdprConsent:
        return this.$t('header-gdpr').toString();
      case EAuthenticationStepType.TrackingConsent:
        return this.$t('header-tracking').toString();
      default:
        return null;
    }
  }

  get label(): string {
    switch (this.consentStep.type) {
      case EAuthenticationStepType.GdprConsent:
        return this.$t('checkbox-label-gdpr').toString();
      case EAuthenticationStepType.TrackingConsent:
        return this.$t('checkbox-label-tracking').toString();
      default:
        return null;
    }
  }

  get description(): string {
    let defaultText: string;
    switch (this.consentStep.type) {
      case EAuthenticationStepType.GdprConsent:
        defaultText = this.$t('default-gdpr-consent-text').toString();
        break;
      case EAuthenticationStepType.TrackingConsent:
        defaultText = this.$t('default-tracking-consent-text').toString();
        break;
    }
    return MergeTagHelper.replaceTags(this.consentStep.data.text || defaultText, {
      entity: this.consentStep.data.textData?.entity,
    });
  }

  toogleValue() {
    this.$emit('change', !this.value, this.consentStep.type);
  }
}
